module.exports = __webpack_public_path__ + "06_face.c5f15c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/06_face.png
// module id = Fx7X
// module chunks = 0